import { useOutsideClick } from '@/hooks/click-outside-hook';
import { Add } from '@mui/icons-material';
import { Box, Chip, Stack, TextField } from '@mui/material';
import { useState, useRef } from 'react';

interface TagAdderProps {
  tagCreated: (tagName: string) => void;
}

export const TagAdder = (props: TagAdderProps) => {
  const [editMode, setEditMode] = useState<boolean | undefined>(undefined);
  const [tagName, setTagName] = useState<string>('');
  const elementRef = useRef<HTMLHeadingElement | null>(null);
  useOutsideClick(elementRef.current, () => setEditMode(false));

  const createTag = (e: React.UIEvent) => {
    props.tagCreated(tagName);
    setTagName('');
    setEditMode(false);
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <h4
      ref={elementRef}
      style={{ display: 'inline-block', margin: 3 }}
      onClick={() => {
        setEditMode(true);
      }}
    >
      {!editMode ? (
        <Chip
          label={
            <Box sx={{ textAlign: 'center', display: 'flex', justifyContent: 'center', justifyItems: 'center' }}>
              <Add />
            </Box>
          }
          style={{ backgroundColor: '#606C38' }}
          onClick={() => setEditMode(true)}
        ></Chip>
      ) : (
        <Chip
          label={
            <Stack direction={'row'} gap={1} alignItems={'center'}>
              <TextField
                autoFocus={true}
                value={tagName}
                variant="standard"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') createTag(e);
                }}
                onChange={(e) => setTagName(e.target.value)}
              />
              <Add onClick={(e) => createTag(e)} />
            </Stack>
          }
          style={{ backgroundColor: '#606C38' }}
        ></Chip>
      )}
    </h4>
  );
};
